import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-layout-enjoy-cl',
  templateUrl: './layout-enjoy-cl.component.html',
  styleUrls: ['./layout-enjoy-cl.component.scss'],
})
export class LayoutEnjoyClComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
